import { authProvider } from '../../authProvider';
import { AxiosHeaders, AxiosRequestHeaders } from 'axios';
import { getConfiguration } from '../shared/utils/configuration';
import { DosingDetailsDto, ProductSizeDto } from '@kotipizzagroup/kotipizza-products-api-client';

export const getRequestHeaders = async (): Promise<AxiosRequestHeaders> => {
  const token = await authProvider.requestApiAccessToken();
  const headers = new AxiosHeaders();
  headers.set('Authorization', `Bearer ${token?.accessToken}`);
  headers.set('Ocp-Apim-Trace', true);
  headers.set('Content-Type', 'application/json');
  return headers;
};

export type EnumEntry = {
  key: string;
  value: number;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function getEnumEntries(givenEnum: any): EnumEntry[] {
  return Object.entries(givenEnum)
    .filter((entry) => !isNaN(Number(entry[0])))
    .map((entry): EnumEntry => {
      return { key: entry[1] as string, value: Number(entry[0]) };
    });
}

export type FieldError = { [key: string]: string[] };

export function showValidationErrors<T>(
  fieldError: FieldError,
  setError: (fieldName: keyof T, error: { type: string; message: string }, options?: { shouldFocus: boolean }) => void,
  t = (value: string) => value
) {
  Object.entries(fieldError).forEach(([key, errors], index) => {
    setError(
      `${key[0].toLowerCase()}${key.slice(1)}` as keyof T,
      {
        type: 'server',
        message: (errors || []).map((error) => t(error)).join('. '),
      },
      { shouldFocus: !index }
    );
  });
}

export const getIngredientCategoryName = (ingredientCategoryId: number, dosingDetails: DosingDetailsDto): string => {
  return dosingDetails?.ingredientCategories?.find((x) => x.ingredientCategoryId === ingredientCategoryId)?.name || '';
};

export const getSizeName = (sizeId: number, productSizes: ProductSizeDto[] | undefined): string => {
  return productSizes?.find((size) => size.productSizeId == sizeId)?.name || '';
};

type Channel = 'campaigns' | 'product-updates' | 'restaurant-updates';

export const postToSlack = async (text: string, channel: Channel): Promise<void> => {
  try {
    const accountInfo = authProvider.getAccountInfo();
    const message = `${text} - ${accountInfo?.name || ''}`;

    const webhookUrl = getConfiguration<string>(`slack.${channel}`, '');
    await fetch(webhookUrl, {
      method: 'POST',
      body: JSON.stringify({ text: message }),
    });
    console.log(`Slack: Successfully sent ${text}`);
  } catch (error) {
    console.error(error);
  }
};
